import { Injectable } from '@angular/core';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ConfirmComponent } from './confirm.component';
import { ConfirmParams } from './confirm.interface';

@Injectable({
  providedIn: 'root'
})
export class ConfirmService {
  constructor(private dialogService: DialogService) {}

  confirm(params: ConfirmParams): Promise<boolean> {

    const data: ConfirmParams = {
      ...params,
      header: params.header || 'Confirmare',
      confirmButtonText: params.confirmButtonText || 'Confirmă',
      cancelButtonText: params.cancelButtonText || 'Înapoi',
      confirmButtonSeverity: params.confirmButtonSeverity || 'primary',
    };

    const ref: DynamicDialogRef = this.dialogService.open(ConfirmComponent, {
      header: data.header,
      width: '30rem',
      modal: true,
      dismissableMask: true,
      data
    });

    return new Promise((resolve) => {
      ref.onClose.subscribe((confirmed: boolean) => {
        resolve(confirmed);
      });
    });
  }
}